export enum CreditNoteType {
  sundry = 'SUNDRY',
  creditInvoice = 'CREDIT INVOICE',
  reInvoice = 'RE INVOICE',
  stockReturn = 'STOCK RETURN',
}
